// extracted by css-extract-rspack-plugin
export default {"list":"SelectedFiltersList_list__PN2By","visibleChip":"SelectedFiltersList_visibleChip__7hdSv","inActiveFilterChip":"SelectedFiltersList_inActiveFilterChip__uyEzP"};